import { type RouteRecordRaw } from 'vue-router'

export interface CreateAuthRoutesOptions {
  RouteName: {
    signIn: string
    oAuth2Callback: string
    loggedOut: string
    signOut: string
  }
}

export function createAuthRoutes(
  options: CreateAuthRoutesOptions
): readonly RouteRecordRaw[] {
  return [
    {
      path: '/sign-in',
      name: options.RouteName.signIn,
      component: () => import('../views/AuthSignIn.vue'),
      meta: {
        allowPublicEntrance: true,
        skipInitialization: true,
        bareLayout: true
      }
    },
    {
      path: '/sign-out',
      name: options.RouteName.signOut,
      component: () => import('../views/AuthSignOut.vue'),
      meta: {
        allowPublicEntrance: true,
        skipInitialization: true,
        bareLayout: true
      }
    },
    {
      // `/oauth2-callback` deliberately omits `skipInitialization` — this
      // route needs the root init sequence to run in parallel with
      // `handleRedirectCallback()`, since `isAuthenticated()` has a retry
      // loop that pauses init until Auth0 finishes processing the callback.
      // If init were skipped here, the target URL would land on an
      // uninitialized app (no user, no SignalR, no feature flags).
      path: '/oauth2-callback',
      name: options.RouteName.oAuth2Callback,
      component: () => import('../views/AuthCallback.vue'),
      meta: {
        allowPublicEntrance: true,
        bareLayout: true
      }
    },
    {
      path: '/oauth2-logout',
      name: options.RouteName.loggedOut,
      component: () => import('../views/AuthLoggedOut.vue'),
      meta: {
        allowPublicEntrance: true,
        skipInitialization: true,
        bareLayout: true
      }
    }
  ]
}
